import AbstractDataBuilder from "../../core/AbstractDataBuilder";
import ClickMatchFamilyNormalizersResolver from "./ClickMatchFamilyNormalizersResolver";
export default class ClickMatchFamilyDataBuilder extends AbstractDataBuilder {
    static create() {
        if (undefined === this.builderInstance) {
            this.builderInstance = new this(new ClickMatchFamilyNormalizersResolver());
        }
        return this.builderInstance;
    }
}
